const enum PathConstants {
  Home = "/",
  Login = "login",
  NotFound = "/notfound",
  Constructions = "constructions",
  Calculations = "calculations",
  CalculationsNote = "note",
  CalculationsResults = "results",
}

export default PathConstants;
